module.exports = "/images/porte-cle.png?203c35e15d69bb6317ed44a41136d662";